var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsapp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63.808,
    height: 63.865,
    viewBox: "0 0 63.808 63.865",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4169",
    "data-name": "Group 4169",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1695",
    "data-name": "Ellipse 1695",
    cx: 30.942,
    cy: 30.942,
    rx: 30.942,
    ry: 30.942,
    transform: "translate(0.776 0.998)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4116",
    "data-name": "Group 4116",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1700",
    "data-name": "Ellipse 1700",
    cx: 25.552,
    cy: 25.552,
    rx: 25.552,
    ry: 25.552,
    transform: "translate(6.388 6.388)",
    fill: "#12bc18"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4101",
    "data-name": "Group 4101",
    transform: "translate(17.625 17.315)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4100",
    "data-name": "Group 4100"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13914",
    "data-name": "Path 13914",
    d: "M6104.742,686.854c.528-1.667.942-3,1.376-4.336.381-1.171.842-2.319,1.148-3.508a2.337,2.337,0,0,0-.161-1.515,15.8,15.8,0,1,1,17.066,8.2,13.133,13.133,0,0,1-8.708-.838c-1.826-.919-3.387-.387-5.064.188C6108.659,685.645,6106.9,686.171,6104.742,686.854Zm4.438-4.41c1.306-.42,2.41-.737,3.485-1.134a2.417,2.417,0,0,1,2.292.185,12.08,12.08,0,0,0,8.854,1.308,12.83,12.83,0,0,0,9.557-16.526,12.818,12.818,0,1,0-23.978,8.954,7.2,7.2,0,0,1,.04,6.453C6109.358,681.858,6109.311,682.041,6109.18,682.444Z",
    transform: "translate(-6104.742 -654.337)",
    fill: "#098409"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13915",
    "data-name": "Path 13915",
    d: "M6203.717,745.2a1.786,1.786,0,0,1,1.843,1.341,19.146,19.146,0,0,1,.933,2.722,2.049,2.049,0,0,1-.562,1.491,1.5,1.5,0,0,0-.124,2.235,12.116,12.116,0,0,0,4.2,3.712c.753.392,1.214.3,1.652-.34,1.323-1.922,1.8-1.223,3.271-.524.313.149.6.348.9.519a2.1,2.1,0,0,1,.271,3.6,4.794,4.794,0,0,1-4.878.8,16.31,16.31,0,0,1-9.975-9.524,4.521,4.521,0,0,1,.879-5.074A6.6,6.6,0,0,1,6203.717,745.2Z",
    transform: "translate(-6192.472 -737.295)",
    fill: "#098409"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4107",
    "data-name": "Group 4107",
    transform: "translate(9.449 10.396)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4106",
    "data-name": "Group 4106"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4103",
    "data-name": "Group 4103",
    transform: "translate(0 4.28)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4102",
    "data-name": "Group 4102"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13916",
    "data-name": "Path 13916",
    d: "M6011.939,642.458a1.2,1.2,0,0,1-1.2-1.2,22.494,22.494,0,0,1,7.731-16.971,1.2,1.2,0,1,1,1.573,1.807,20.1,20.1,0,0,0-6.908,15.163A1.2,1.2,0,0,1,6011.939,642.458Z",
    transform: "translate(-6010.741 -623.996)",
    fill: "#93f422"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4105",
    "data-name": "Group 4105",
    transform: "translate(10.776)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4104",
    "data-name": "Group 4104"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13917",
    "data-name": "Path 13917",
    d: "M6135.836,579.017a1.2,1.2,0,0,1-.594-2.239,22.412,22.412,0,0,1,4.457-1.93,1.2,1.2,0,0,1,.708,2.289,20,20,0,0,0-3.979,1.724A1.194,1.194,0,0,1,6135.836,579.017Z",
    transform: "translate(-6134.637 -574.794)",
    fill: "#93f422"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4114",
    "data-name": "Group 4114",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4109",
    "data-name": "Group 4109"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4108",
    "data-name": "Group 4108"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13918",
    "data-name": "Path 13918",
    d: "M5934.05,519.14a31.933,31.933,0,1,1,22.584-54.51,1.2,1.2,0,0,1-1.694,1.694,29.544,29.544,0,1,0,0,41.782,1.2,1.2,0,0,1,1.694,1.694A31.84,31.84,0,0,1,5934.05,519.14Z",
    transform: "translate(-5902.109 -455.275)",
    fill: "#12bc18"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4111",
    "data-name": "Group 4111",
    transform: "translate(60.823 34.289)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4110",
    "data-name": "Group 4110"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13919",
    "data-name": "Path 13919",
    d: "M6602.582,854.7a1.211,1.211,0,0,1-.248-.026,1.2,1.2,0,0,1-.925-1.419c.188-.89.335-1.8.439-2.7a1.2,1.2,0,0,1,2.38.275c-.113.977-.273,1.96-.476,2.922A1.2,1.2,0,0,1,6602.582,854.7Z",
    transform: "translate(-6601.382 -849.493)",
    fill: "#12bc18"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4113",
    "data-name": "Group 4113",
    transform: "translate(57.907 16.333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4112",
    "data-name": "Group 4112"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13920",
    "data-name": "Path 13920",
    d: "M6572.562,657.743a1.2,1.2,0,0,1-1.194-1.116A29.465,29.465,0,0,0,6568,644.809a1.2,1.2,0,0,1,2.116-1.123,31.844,31.844,0,0,1,3.642,12.777,1.2,1.2,0,0,1-1.113,1.277Z",
    transform: "translate(-6567.86 -643.05)",
    fill: "#12bc18"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4115",
    "data-name": "Group 4115",
    transform: "translate(16.239 15.928)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13921",
    "data-name": "Path 13921",
    d: "M6088.8,670.915c.528-1.667.942-3,1.375-4.336.381-1.171.842-2.319,1.149-3.508a2.341,2.341,0,0,0-.161-1.515,15.8,15.8,0,1,1,17.065,8.2,13.134,13.134,0,0,1-8.708-.838c-1.825-.919-3.387-.387-5.063.188C6092.72,669.706,6090.956,670.232,6088.8,670.915Zm4.437-4.41c1.306-.42,2.411-.737,3.485-1.134a2.418,2.418,0,0,1,2.292.185,12.078,12.078,0,0,0,8.854,1.308,12.83,12.83,0,0,0,9.557-16.526,12.818,12.818,0,1,0-23.978,8.954,7.2,7.2,0,0,1,.04,6.453C6093.419,665.919,6093.372,666.1,6093.24,666.505Z",
    transform: "translate(-6088.803 -638.398)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13922",
    "data-name": "Path 13922",
    d: "M6187.778,729.259a1.786,1.786,0,0,1,1.843,1.341,19.2,19.2,0,0,1,.933,2.722,2.051,2.051,0,0,1-.562,1.491,1.5,1.5,0,0,0-.124,2.235,12.12,12.12,0,0,0,4.2,3.712c.753.392,1.215.3,1.652-.34,1.323-1.922,1.8-1.223,3.271-.524.313.149.6.348.9.518a2.094,2.094,0,0,1,.271,3.6,4.793,4.793,0,0,1-4.878.8,16.309,16.309,0,0,1-9.975-9.524,4.521,4.521,0,0,1,.879-5.074A6.6,6.6,0,0,1,6187.778,729.259Z",
    transform: "translate(-6176.533 -721.356)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.26f9ca18250fac3181d47dfd4499f4f9.svg";
export { ForwardRef as ReactComponent };